module.exports = __webpack_public_path__ + "static/media/drircation.1bec339b.png";